export default "__VITE_ASSET__116233fb__"